/*=========================================================================================
  File Name: module-licenseinfo-state.js
  Description: LicenseInfo Module State
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

export default {
	LicenseInfo: {}, // Thông tin license
	Config: {},
	LicenseWarning: {},
	LicenseInfoNotification: null
};
